((ForceLang) => {
  'use strict';

  const matrix = {};
  const urlQuery = window.location.search;
  const queryStrip = 5;

  let lang;

  const buildMatrixObject = (languageMatrix) => {
    const matrixArray = languageMatrix.split(',');

    for (let i = 0; i < matrixArray.length; i++) {
      const languageArray = matrixArray[i].split('=');
      matrix[languageArray[0]] = languageArray[1];
    }
  };

  const getQuery = () => {
    const queries = urlQuery.substr(1, urlQuery.length).split('&');
    let query;

    for (let i = 0; i < queries.length; i++) {
      if (queries[i].indexOf('lang=') >= 0) {
        query = queries[i];
        break;
      }
    }

    lang = query.substr(queryStrip, query.length);
  };

  const setCookie = () => {
    const thirtyMinutes = 1 / 48;
    window.Cookies.set('BVAForceLang', 'true', {
      expires: thirtyMinutes
    });
  };

  const checkCookie = () => {
    return window.Cookies.get('BVAForceLang');
  };

  const changeLanguage = () => {
    const langifyId = matrix[lang];

    $(document).ready(() => {
      if (langifyId && window.langify && !checkCookie()) {
        if (langifyId !== langify.helper.getSelectedLanguage()) {
          window.langify.helper.saveLanguage(langifyId);
          setCookie();
        }
      }
    });
  };

  const init = (languageMatrix) => {
    buildMatrixObject(languageMatrix);
    getQuery();
    changeLanguage();
  };

  ForceLang.init = init;
})(window.ForceLang = window.ForceLang || {});
